//
//
//
//
//
//

export default {
  name: "list-header",
  props:['templateBoard'],
  data(){
    return{

    }
  }
}



// WEBPACK FOOTER //
// ./src/components/temporary/list-header.vue